module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "600px",
      "persistent": "",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-alert', {
    attrs: {
      "color": "success",
      "icon": "check_circle",
      "value": _vm.alert,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n      Event has been saved and submitted for Review\n    ")]), _vm._v(" "), _c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Add new Event")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Title",
      "required": "",
      "prepend-icon": "mdi-textbox"
    },
    model: {
      value: (_vm.event.title),
      callback: function($$v) {
        _vm.$set(_vm.event, "title", $$v)
      },
      expression: "event.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenu),
      callback: function($$v) {
        _vm.datepickermenu = $$v
      },
      expression: "datepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Event Date",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.event, "eventdate", $$v)
      },
      expression: "event.eventdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.event.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.event, "eventdate", $$v)
      },
      expression: "event.eventdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.timepickermenu),
      callback: function($$v) {
        _vm.timepickermenu = $$v
      },
      expression: "timepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Start Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "starteventtime", $$v)
      },
      expression: "event.starteventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.event.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "starteventtime", $$v)
      },
      expression: "event.starteventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.endtimepickermenu),
      callback: function($$v) {
        _vm.endtimepickermenu = $$v
      },
      expression: "endtimepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "End Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "endeventtime", $$v)
      },
      expression: "event.endeventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.event.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "endeventtime", $$v)
      },
      expression: "event.endeventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Location",
      "required": "",
      "prepend-icon": "mdi-google-maps"
    },
    model: {
      value: (_vm.event.location),
      callback: function($$v) {
        _vm.$set(_vm.event, "location", $$v)
      },
      expression: "event.location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Link",
      "prepend-icon": "link"
    },
    model: {
      value: (_vm.event.link),
      callback: function($$v) {
        _vm.$set(_vm.event, "link", $$v)
      },
      expression: "event.link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "rows": "3",
      "required": "",
      "prepend-icon": "mdi-file-document",
      "label": "Event Description"
    },
    model: {
      value: (_vm.event.description),
      callback: function($$v) {
        _vm.$set(_vm.event, "description", $$v)
      },
      expression: "event.description"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    style: ({
      color: _vm.buttonColor
    }),
    attrs: {
      "type": "submit",
      "flat": ""
    }
  }, [_vm._v("Save")])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68d71ee4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/events/NewEventsModal.vue
// module id = 1696
// module chunks = 17